import { render, staticRenderFns } from "./NavView.vue?vue&type=template&id=392482ac&"
var script = {}
import style0 from "./NavView.vue?vue&type=style&index=0&id=392482ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports